import createReducer from "./createReducer";
import { SUPPRESS_SUCCESS_GROWL } from "utils/constants";
import { addFiltering } from "./common/Filtering";
import { addColumnFilters } from "./common/ColumnFilters";

const initialState = {
	items: [],
	isLoading: false,
	hasErrorLoading: false,

	linkedCreatives: [],
	isLoadingLinkedCreatives: false,
	hasErrorLoadingLinkedCreatives: false,

	sharableLinks: [],
	isLoadingSharableLinks: false,
	hasErrorLoadingSharableLinks: false,
};

const CREATIVE_PREVIEWS_ACTIONS = {
	LOAD_SHARABLE_LINK_AJAX: "LOAD_SHARABLE_LINK_AJAX",

	LOAD_SHARABLE_LINKS_AJAX: "LOAD_SHARABLE_LINKS_AJAX",
	LOAD_SHARABLE_LINKS_SUCCESS: "LOAD_SHARABLE_LINKS_SUCCESS",
	LOAD_SHARABLE_LINKS_ERROR: "LOAD_SHARABLE_LINKS_ERROR",

	FETCH_CREATIVE_PREVIEWS_AJAX: "FETCH_CREATIVE_PREVIEWS_AJAX",
	FETCH_CREATIVE_PREVIEWS_SUCCESS: "FETCH_CREATIVE_PREVIEWS_SUCCESS",
	FETCH_CREATIVE_PREVIEWS_ERROR: "FETCH_CREATIVE_PREVIEWS_ERROR",
	FETCH_CREATIVE_PREVIEWS_CANCEL: "FETCH_CREATIVE_PREVIEWS_CANCEL",

	RESET_CREATIVE_PREVIEW_LIST: "RESET_CREATIVE_PREVIEWS",

	DELETE_CREATIVE_PREVIEW_AJAX: "DELETE_CREATIVE_PREVIEW_AJAX",
	DELETE_CREATIVE_PREVIEW_SUCCESS: "DELETE_CREATIVE_PREVIEW_SUCCESS",
	DELETE_CREATIVE_PREVIEW_ERROR: "DELETE_CREATIVE_PREVIEW_ERROR",

	EXTEND_CREATIVE_PREVIEW_AJAX: "EXTEND_CREATIVE_PREVIEW_AJAX",
	EXTEND_CREATIVE_PREVIEW_SUCCESS: "EXTEND_CREATIVE_PREVIEW_SUCCESS",
	EXTEND_CREATIVE_PREVIEW_ERROR: "EXTEND_CREATIVE_PREVIEW_ERROR",

	MAKE_CREATIVE_PREVIEW_PERMANENT_AJAX: "MAKE_CREATIVE_PREVIEW_PERMANENT_AJAX",
	MAKE_CREATIVE_PREVIEW_PERMANENT_SUCCESS: "MAKE_CREATIVE_PREVIEW_PERMANENT_SUCCESS",
	MAKE_CREATIVE_PREVIEW_PERMANENT_ERROR: "MAKE_CREATIVE_PREVIEW_PERMANENT_ERROR",

	FETCH_PREVIEW_LINKED_CREATIVES_AJAX: "FETCH_PREVIEW_LINKED_CREATIVES_AJAX",
	FETCH_PREVIEW_LINKED_CREATIVES_SUCCESS: "FETCH_PREVIEW_LINKED_CREATIVES_SUCCESS",
	FETCH_PREVIEW_LINKED_CREATIVES_ERROR: "FETCH_PREVIEW_LINKED_CREATIVES_ERROR",
	CLEAR_PREVIEW_LINKED_CREATIVES: "CLEAR_PREVIEW_LINKED_CREATIVES",
};

export const handlers = {
	[CREATIVE_PREVIEWS_ACTIONS.FETCH_CREATIVE_PREVIEWS_AJAX]: getCreativePreviews,
	[CREATIVE_PREVIEWS_ACTIONS.FETCH_CREATIVE_PREVIEWS_SUCCESS]: getCreativePreviewsSuccess,
	[CREATIVE_PREVIEWS_ACTIONS.FETCH_CREATIVE_PREVIEWS_ERROR]: genericPreviewError,

	[CREATIVE_PREVIEWS_ACTIONS.RESET_CREATIVE_PREVIEW_LIST]: resetCreativePreviewsList,

	[CREATIVE_PREVIEWS_ACTIONS.DELETE_CREATIVE_PREVIEW_AJAX]: genericPreviewRequest,
	[CREATIVE_PREVIEWS_ACTIONS.DELETE_CREATIVE_PREVIEW_SUCCESS]: deletePreviewSuccess,
	[CREATIVE_PREVIEWS_ACTIONS.DELETE_CREATIVE_PREVIEW_ERROR]: genericPreviewError,

	[CREATIVE_PREVIEWS_ACTIONS.EXTEND_CREATIVE_PREVIEW_AJAX]: genericPreviewRequest,
	[CREATIVE_PREVIEWS_ACTIONS.EXTEND_CREATIVE_PREVIEW_SUCCESS]: extendTtlSuccess,
	[CREATIVE_PREVIEWS_ACTIONS.EXTEND_CREATIVE_PREVIEW_ERROR]: genericPreviewError,

	[CREATIVE_PREVIEWS_ACTIONS.MAKE_CREATIVE_PREVIEW_PERMANENT_AJAX]: genericPreviewRequest,
	[CREATIVE_PREVIEWS_ACTIONS.MAKE_CREATIVE_PREVIEW_PERMANENT_SUCCESS]: makePermanentSuccess,
	[CREATIVE_PREVIEWS_ACTIONS.MAKE_CREATIVE_PREVIEW_PERMANENT_ERROR]: genericPreviewError,

	[CREATIVE_PREVIEWS_ACTIONS.FETCH_PREVIEW_LINKED_CREATIVES_AJAX]: getLinkedCreativesRequest,
	[CREATIVE_PREVIEWS_ACTIONS.FETCH_PREVIEW_LINKED_CREATIVES_SUCCESS]: getLinkedCreativesSuccess,
	[CREATIVE_PREVIEWS_ACTIONS.FETCH_PREVIEW_LINKED_CREATIVES_ERROR]: getLinkedCreativesError,
	[CREATIVE_PREVIEWS_ACTIONS.CLEAR_PREVIEW_LINKED_CREATIVES]: resetLinkedCreatives,

	[CREATIVE_PREVIEWS_ACTIONS.LOAD_SHARABLE_LINKS_AJAX]: initLoadSharableLinks,
	[CREATIVE_PREVIEWS_ACTIONS.LOAD_SHARABLE_LINKS_SUCCESS]: loadSharableLinksSuccess,
};

let reducerConfig = {
	typeRoot: "CREATIVE_PREVIEWS",
	actionTypes: CREATIVE_PREVIEWS_ACTIONS,
	actionCreators: {
		clearCreativePreviews,
		loadCreativePreviews,
	},
	initialState,
	handlers,
};

reducerConfig = addFiltering(reducerConfig, { sort: "name:DESC" });
reducerConfig = addColumnFilters(reducerConfig, {
	type: {
		name: "type",
		type: "Checkbox",
		displayName: "Type",
	},
});

export function loadSharableLinks(libraryId, creativeIds, previewName, isPermanent){
	/*
		This creates and dispatches multiple actions if there are multiple creativeIds.

		For multiple creatives, we request an additional multishare link, to the same endpoint,
		where `previewId` is a comma separated list of their IDs, and creativeId is "all"

		Otherwise, these are both just the item in creativeIds.
	*/
	return (dispatch, getState) => {
		const state = getState();
		const creatives = state.creatives?.items || [];

		const actions = [];

		if(creativeIds.length > 1){
			actions.push({
				type: CREATIVE_PREVIEWS_ACTIONS.LOAD_SHARABLE_LINK_AJAX,
				meta: SUPPRESS_SUCCESS_GROWL,
				AJAX: {
					url: "creative-preview/share",
					method: "post",
					data: {
						campaignId: libraryId,
						isPermanent,
						name: previewName,
						previewId: creativeIds.join(","),
						previewType: "tia",
					},
					success: "LOAD_SHARABLE_LINK_SUCCESS",
					error: "LOAD_SHARABLE_LINK_ERROR",
				},
				payload: {
					creativeId: "all",
					previewName,
				},
			});
		}

		actions.push(...creativeIds.map((creativeId) => {
			const creative = creatives.find(creative => creative.id === creativeId);

			return ({
				type: CREATIVE_PREVIEWS_ACTIONS.LOAD_SHARABLE_LINK_AJAX,
				meta: SUPPRESS_SUCCESS_GROWL,
				AJAX: {
					url: "creative-preview/share",
					method: "post",
					data: {
						campaignId: libraryId,
						isPermanent,
						name: creative.name,
						previewId: creativeId,
						previewType: "tia",
					},
					success: "LOAD_SHARABLE_LINK_SUCCESS",
					error: "LOAD_SHARABLE_LINK_ERROR",
				},
				payload: {
					creativeId,
					creative,
					name: creative.name,
				},
			});
		}));

		return Promise.resolve(dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.LOAD_SHARABLE_LINKS_AJAX,
		}))
			.then(() => {
				return Promise.all(actions.map(action => dispatch(action)));
			})
			.then((results) => {
				return dispatch({
					type: CREATIVE_PREVIEWS_ACTIONS.LOAD_SHARABLE_LINKS_SUCCESS,
					payload: results,
				});
			})
			.catch((error) => {
				return dispatch({
					type: CREATIVE_PREVIEWS_ACTIONS.LOAD_SHARABLE_LINKS_ERROR,
					payload: error,
				});
			});
	};
}

export function makeCreativePreviewPermanent(libraryId, data) {
	return ((dispatch) => {
		return dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.MAKE_CREATIVE_PREVIEW_PERMANENT_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				method: 'post',
				url: `ui/creative-preview/${libraryId}/bulk-share-extend`,
				data,
				success: CREATIVE_PREVIEWS_ACTIONS.MAKE_CREATIVE_PREVIEW_PERMANENT_SUCCESS,
				error: CREATIVE_PREVIEWS_ACTIONS.MAKE_CREATIVE_PREVIEW_PERMANENT_ERROR,
			},
			payload: data,
		});
	});
}

export function extendCreativePreview(libraryId, data) {
	return ((dispatch) => {
		return dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.EXTEND_CREATIVE_PREVIEW_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				method: 'post',
				url: `ui/creative-preview/${libraryId}/bulk-share-extend`,
				data,
				success: CREATIVE_PREVIEWS_ACTIONS.EXTEND_CREATIVE_PREVIEW_SUCCESS,
				error: CREATIVE_PREVIEWS_ACTIONS.EXTEND_CREATIVE_PREVIEW_ERROR,
			},
		});
	});
}

export function deleteCreativePreview(libraryId, data) {
	return ((dispatch) => {
		return dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.DELETE_CREATIVE_PREVIEW_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				method: 'delete',
				url: `ui/creative-preview/${libraryId}/bulk-share-delete`,
				success: CREATIVE_PREVIEWS_ACTIONS.DELETE_CREATIVE_PREVIEW_SUCCESS,
				error: CREATIVE_PREVIEWS_ACTIONS.DELETE_CREATIVE_PREVIEW_ERROR,
				data,
			},
			payload: data,
		});
	});
}

export function loadCreativePreviews(libraryId, cancelToken) {
	return (dispatch, getState) => {
		let state = getState();
		let { filterInfo } = state.creativePreviews;

		return dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.FETCH_CREATIVE_PREVIEWS_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				method: "get",
				params: filterInfo,
				url: `ui/creative-preview/${libraryId}/bulk-share-get`,
				success: CREATIVE_PREVIEWS_ACTIONS.FETCH_CREATIVE_PREVIEWS_SUCCESS,
				error: CREATIVE_PREVIEWS_ACTIONS.FETCH_CREATIVE_PREVIEWS_ERROR,
				cancel: CREATIVE_PREVIEWS_ACTIONS.FETCH_CREATIVE_PREVIEWS_CANCEL,
				cancelToken,
			},
		});
	};
}

export function clearCreativePreviews() {
	return (dispatch) => {
		dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.RESET_CREATIVE_PREVIEW_LIST,
		});
		return Promise.resolve({ success: true });
	};
}

export function loadLinkedCreatives(libraryId, previewId) {
	return ((dispatch) => {
		return dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.FETCH_PREVIEW_LINKED_CREATIVES_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives?advancedFilter=in(id,+${previewId})&fields=id,name,approval`,
				success: CREATIVE_PREVIEWS_ACTIONS.FETCH_PREVIEW_LINKED_CREATIVES_SUCCESS,
				error: CREATIVE_PREVIEWS_ACTIONS.FETCH_PREVIEW_LINKED_CREATIVES_ERROR,
			},
		});
	});
}

export function clearLinkedCreatives() {
	return ((dispatch) => {
		return dispatch({
			type: CREATIVE_PREVIEWS_ACTIONS.CLEAR_PREVIEW_LINKED_CREATIVES,
		});
	});
}

export function getCreativePreviews(state, action) {
	return {
		...state,
		items: [],
		isLoading: true,
		hasErrorLoading: false,
	};
}

export function getCreativePreviewsSuccess(state, action) {
	let { data } = action.payload;

	let items = data?.items || [];
	if (items.length) {
		const currentDate = new Date().getTime();
		items = items.map(((v) => {
			const { type, dateExpires, isPermanent, publicId } = v;
			const dateExpiresTime = new Date(dateExpires)?.getTime();

			let status = "";
			if (publicId === null && type === "mockup") {
				status = "not_shared";
			} else if ((type === "tia" || type  === "basic" || type === "mockup") && (isPermanent || (currentDate < dateExpiresTime))) {
				status = "available";
			} else if ((type === "tia" || type === "basic" || type === "mockup") && !isPermanent && (dateExpiresTime <= currentDate)) {
				status = "expired";
			}

			return { ...v, status };
		}));
	}

	return {
		...state,
		...data,
		items,
		isLoading: false,
		hasErrorLoading: false,
	};
}

function resetCreativePreviewsList(state, action) {
	return {
		...initialState,
		filterInfo: state.filterInfo,
		columnFilters:state.columnFilters,
	};
}

export function getLinkedCreativesRequest(state, action) {
	return {
		...state,
		linkedCreatives: [],
		isLoadingLinkedCreatives: true,
		hasErrorLoadingLinkedCreatives: false,
	};
}

export function getLinkedCreativesSuccess(state, action) {
	let { data } = action.payload;

	return {
		...state,
		linkedCreatives: data?.items || [],
		isLoadingLinkedCreatives: false,
		hasErrorLoadingLinkedCreatives: false,
	};
}

export function getLinkedCreativesError(state, action) {
	return {
		...state,
		isLoadingLinkedCreatives: false,
		hasErrorLoadingLinkedCreatives: true,
	};
}

export function resetLinkedCreatives(state, action) {
	return {
		...state,
		linkedCreatives: [],
		isLoadingLinkedCreatives: false,
		hasErrorLoadingLinkedCreatives: false,
	};
}

export function deletePreviewSuccess(state, action) {
	let deletedIds = action.payload.original.items.map(({ id }) => id)
		, existingItems = state.items
		;

	let newItems = existingItems.filter(preview => !deletedIds.includes(preview.id));

	return {
		...state,
		items: newItems,
		isLoading: false,
		hasErrorLoading: false,
	};
}

export function extendTtlSuccess(state, action) {
	let updatedPreviews = action.payload.data;
	let newItems = state.items.map((preview) => {
		let updated = updatedPreviews.find(({ id }) => id === preview.id);
		if(updated && !updated.isPermanent){
			return Object.assign({}, preview, { dateExpires: updated.dateExpires });
		}
		return preview;
	});

	return {
		...state,
		items: newItems,
		isLoading: false,
		hasErrorLoading: false,
	};
}

export function makePermanentSuccess(state, action) {
	let updatedPreviews = action.payload.data.map(({ id }) => id);
	let newItems = state.items.map((preview) => {
		if (updatedPreviews.includes(preview.id)) {
			return Object.assign({}, preview, {
				dateExpires: null,
				isPermanent: true,
			});
		}

		return preview;
	});

	return {
		...state,
		items: newItems,
		isLoading: false,
		hasErrorLoading: false,
	};
}

/* generic reducers for api calls where the app doesn't do anything with the data */
export function genericPreviewRequest(state, action) {
	return {
		...state,
		isLoading: true,
		hasErrorLoading: false,
	};
}
export function genericPreviewError(state, action) {
	return {
		...state,
		isLoading: false,
		hasErrorLoading: true,
	};
}

export function initLoadSharableLinks(state, action){
	return {
		...state,
		sharableLinks: [],
		isLoadingSharableLinks: true,
		hasErrorLoadingSharableLinks: false,
	};
}

export function loadSharableLinksSuccess(state, action){
	const { payload = []} = action || {};

	const sharableLinks = payload.map((item) => {
		const creative = item?.payload?.original?.creative || {};
		const previewName = item?.payload?.original?.previewName || "Preview";
		return {
			...item?.payload?.data?.payload, /*
				This is the payload for each individual request to the share endpoint.
				We expect this to look like:
				{
					url,
					miniUrl,
					publicId,
					qrCode,
				}
			*/
			previewName: creative.name || previewName, /*
				For sharing multiple creatives, we have an item per shared creative, and one for the group.
				For the individual creatives, we use the creative name (from creatives in the store).
				For the group, we use the user-submitted preview name.
			*/
			creative, /*
				Because PRVW and legacy Preview each don't support all Creative types, we have to route
				the share links we create based on the Creative's adType, and possibly approval/status,
				so we put this into the sharableLinks state for reference.
			*/
		};
	});

	return {
		...state,
		sharableLinks,
		isLoadingSharableLinks: false,
		hasErrorLoadingSharableLinks: false,
	};
}

export function loadSharableLinksError(state, action){
	return {
		...state,
		sharableLinks: [],
		isLoadingSharableLinks: false,
		hasErrorLoadingSharableLinks: true,
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const CreativePreviews = reducerConfig.actionCreators;
